import React from "react";

/* Skeleton placeholders to keep layout stable while data loads.
 * Uses CSS shimmer animation defined in App.css. */

export function ProductCardSkeleton() {
  return (
    <div className="card-soft block overflow-hidden" data-testid="skeleton-product">
      <div className="aspect-[4/5] skeleton" />
      <div className="p-3 sm:p-4 space-y-2">
        <div className="skeleton-line w-3/4" />
        <div className="flex justify-between items-center">
          <div className="skeleton-line w-1/3 h-5" />
          <div className="w-9 h-9 skeleton rounded-full" />
        </div>
      </div>
    </div>
  );
}

export function ProductGridSkeleton({ count = 6 }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4"
          data-testid="skeleton-grid">
      {Array.from({ length: count }, (_, i) => <ProductCardSkeleton key={i} />)}
    </div>
  );
}

export function CategoryChipsSkeleton({ count = 6 }) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1" data-testid="skeleton-chips">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="skeleton rounded-full" style={{ width: 90, height: 36 }} />
      ))}
    </div>
  );
}

export function HeroSkeleton() {
  return (
    <div className="rounded-3xl overflow-hidden h-64 sm:h-80 skeleton" data-testid="skeleton-hero" />
  );
}

export function CardsRowSkeleton({ count = 3 }) {
  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-4">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="card-soft p-3 sm:p-5 flex items-center gap-3">
          <div className="w-9 h-9 rounded-full skeleton shrink-0" />
          <div className="flex-1 space-y-1.5">
            <div className="skeleton-line w-3/4" />
            <div className="skeleton-line w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
